import {Component, OnInit, OnDestroy} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {FullscreenService} from '../../../services/fullscreen.service';
import {NotificationService} from '../../../services/notification.service';

import {AuthService} from '../../../services/auth.service';
import {LoadingPage} from '../../../../shared/components/loading/loading.page.component';
import {ScormCloudService} from '../../../services/scorm-cloud.service';
import {DomainService} from '../../../services/domain.service';

@Component({
  selector: 'itpx-scorm-cloud',
  templateUrl: './scorm-cloud.component.html',
  styleUrls: ['./scorm-cloud.component.css']
})
export class ScormCloudComponent extends LoadingPage implements OnInit, OnDestroy {

  private player: any;
  private deliverableId: any;
  private iframeUrl: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private scormCloudService: ScormCloudService,
    private authService: AuthService,
    private notificationService: NotificationService,
    private fullscreenService: FullscreenService,
  ) {
    super();
    this.player = window;
  }

  ngOnInit() {
    this.fullscreenService.onFullscreen()
      .skip(1)
      .subscribe(_ => this.router.navigate(['app/dummy']));

    let routeData = this.route.params
      .take(1)
      .map(params => ({deliverableId: params['deliverableId'], registrationId: params['registrationId']}))
      .cacheResult();

    routeData
      .subscribe(data => this.deliverableId = data);

    // Initially start the scorm player
    routeData
      .flatMap(data => this.scormCloudService.getRegistrations(data.registrationId, window.location.origin))
      .bindToLifecycle(this)
      .map(body => body.data)
      .subscribe(
        data => {
          this.ready();
          this.iframeUrl = data.launchUrl;
        },
        err => this.handleError(err)
      );
  }

  private handleError(error: any) {
    this.notificationService.error(error, 'Failed');
    this.ready();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/content/scormcloud/scorm-cloud.component.ts